import React, { PureComponent } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { HashLink as Link } from 'react-router-hash-link';
import { sendShareListingEmail } from './actions';
import { ShareFormSchema } from '../global/validation';
import { hideActiveModal, openActiveModal } from '../global/forms/ratingForm';
import { pushSuccess } from '../global/actions';

export const LoginPrompt = ({ id, hideActiveModal }) => {
  return (
    <div className="modal text-center" id={id} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-body">
            <h5>You must log in before continuing.</h5>
            <span className="link mr-3" onClick={hideActiveModal}>Cancel</span>
            <Link to={`/login?redirect=${window.location.hash.substr(1)}`} onClick={hideActiveModal}>Go to Login</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  admin: state.Global,
  booking: state.Booking
});

class EmailOptionsModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        currentUser: props.values.currentUser,
        listingId: props.values.listingId,
        recipients: '',
        message: ''
      }
    }
    this.submitForm = this.submitForm.bind(this);
    this.openActiveModal = this.openActiveModal.bind(this);
    this.hideActiveModal = this.hideActiveModal.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
  }

  componentDidMount() {
    this.openActiveModal();
    setTimeout(() => window.addEventListener('click', this.clickHandler), 500);
  }

  componentWillUnmount() {
    this.hideActiveModal();
    window.removeEventListener('click', this.clickHandler);
  }

  clickHandler({ target }) {
    if (document.getElementsByClassName('modal-content')[0].contains(target)) {
      //Nothing needs to be done
    } else {
      this.hideActiveModal();
    }
  }

  hideActiveModal = () => {
    hideActiveModal(this.props)
  }

  openActiveModal = () => {
    openActiveModal('shareModal');
  }

  submitForm(values, { resetForm }) {
    let { dispatch } = this.props;
    let emailList = values.recipients;
    for (let i = emailList.length - 1; i > 0; i--) {
      if (emailList[i] === " " || emailList[i] === ",") {
        emailList = emailList.substr(0, emailList.length - 1);
        continue;
      }
    }
    dispatch(sendShareListingEmail(values.listingId, emailList.concat(",", values.currentUser.email), values.message))
    dispatch(pushSuccess('Email sent successfully'));
    resetForm(this.state.initialValues);
    this.hideActiveModal();
  }

  render() {
    let { admin } = this.props;
    if (!admin.userId) {
      return <LoginPrompt id="shareModal" hideActiveModal={this.hideActiveModal} />
    }
    // Add email address validation
    return (
      <Formik
        initialValues={this.state.initialValues}
        onSubmit={this.submitForm}
        validationSchema={ShareFormSchema}>
        {({ resetForm, errors }) => (
          <Form>
            <div className="modal" id="shareModal" tabIndex="-1">
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Send this listing to:</h5>
                  </div>
                  <div className="modal-body">
                    <div className="w-100">
                      <ErrorMessage name='recipients' render={message => {
                        return (
                          <div className="error-message w-100 pl-3">{message}</div>
                        )
                      }} />
                      <Field
                        name="recipients"
                        placeholder="Enter email addresses separated by commas."
                        component="textarea"
                        className="form-control"
                      />
                    </div>
                    <div className="w-100">
                      <br></br>
                      <Field
                        name="message"
                        placeholder="Enter custom message (optional)"
                        component="textarea"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <label
                      className="mt-auto mb-auto"
                      onClick={() => {
                        resetForm(this.state.initialValues);
                        this.hideActiveModal();
                      }}
                      data-dismiss="modal">
                      Cancel
                    </label>
                    <button className="btn btn-primary" type="submit">Send</button>
                  </div>
                </div>
              </div></div></Form>
        )}</Formik>
    )
  }
}

export default withRouter(connect(mapStateToProps)(EmailOptionsModal));
